import { Checkbox, DataSource, Label, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierCancellationsDetail extends Layout {
    checkboxExcludeReasonCodes: Checkbox;
    labelAdded: Label;
    labelCancellationDetail3: Label;
    labelCancellationDetail4: Label;
    labelCancellationDetail: Label;
    labelDividend: Label;
    labelDivisor: Label;
    labelLeftParen: Label;
    labelRightParen: Label;
    labelSubtracted: Label;
    labelWeight: Label;
    panelFormula: Panel;
    sourceCarrierScorecardDetail: DataSource;
    tabScoringDetails: Tab;
    tabsetScoringDetails: Tabset;
    textboxEndOfPeriod: Textbox;
    textboxMinimumRecords: Textbox;
    textboxReasonCodes: Textbox;
    textboxStartOfPeriod: Textbox;
    textboxWeight: Textbox;
}
